import Axios from '@/plugins/axios'
import { onlineUrl } from '@/utils/config';

// 客户详情
export function customerDetail(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/detail`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 关注&&取消关注客户 
export function followUpCustomer(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/focus`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}
// 转为成交客户
export function convertToTransaction(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/convert-to-transaction`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}
// 编辑客户信息
export function editCustomer(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/update-customer`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}
// 添加联系人
export function contactList(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/contact-list`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}


// 添加联系人
export function addContact(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/add-contact`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 编辑联系人
export function editContact(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/update-contact`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}
// 删除联系人
export function deleteContact(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/del-contact`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}
// 添加到收件人
export function addConsignee(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/add-recipient`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 添加客户标签
export function addCustomerTag(params) {
  const config = {
    url: `${ onlineUrl }/seamark/tag/add-customer-tag`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}
// 删除客户标签
export function deleteCustomerTag(params) {
  const config = {
    url: `${ onlineUrl }/seamark/tag/remove-customer-tag`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 保存我的标签
export function saveTags(params) {
  const config = {
    url: `${ onlineUrl }/seamark/tag/save`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}
// 删除我的标签
export function delTags(params) {
  const config = {
    url: `${ onlineUrl }/seamark/tag/delete`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}
// 编辑我的标签
export function editTags(params) {
  const config = {
    url: `${ onlineUrl }/seamark/tag/edit`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 管理标签列表
export function tagsList(params) {
  const config = {
    url: `${ onlineUrl }/seamark/tag/list`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}


// 操作日志
export function logList(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/log-list`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}
// 添加到收件人
export function addAddressee(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/add-recipient`,
    method: 'POST',
    data: params,
    // noMessage: true
  }
  return Axios(config)
}

// 搜索行业
export function industryByKeyword(params) {
  const config = {
    url: `/seamark/supplier/customer/industry/by-keyword`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 搜索职业
export function userTitleByKeyword(params) {
  const config = {
    url: `/seamark/supplier/customer/user-title/by-keyword`,
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 客户下所有联系人邮件发送记录
export function allContactEmailSendRecord(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/all-contact/email-send-record`,
    method: 'POST',
    data:params
  }
  return Axios(config);
}

// 校验以客户纬度是否可以发送邮件
export function customerSendEmailVerify(params) {
  const config = {
    url: `${ onlineUrl }/seamark/supplier-customer/customer/send-email-verify`,
    method: 'POST',
    data:params,
    noMessage:true
  }
  return Axios(config);
}